import React from 'react';
import { matchPath, Redirect, useLocation } from 'react-router-dom';

import { book } from './books';

const legacyRedirects: Record<string, (params: Record<string, string>) => string> = {
  '/user/jobslistings': () => book.jobsListings,
  '/user/jobsApplicants': () => book.jobsListings,
  '/user/jobsprepaid': () => book.jobsPrepaid,
  '/user/jobsprepaid/:id': ({ id }) => book.jobsPrepaidDetail(id),
  '/user/jobsApplicants/:id': ({ id }) => book.jobsApplicants(id),
  '/user/jobsApplicantDetail/:eguid/:applicationId': (
    { eguid, applicationId }
  ) => book.jobsApplicantDetail(eguid, applicationId)
};

export const legacyEmployerPaths = Object.keys(legacyRedirects);

export const getLegacyEmployerPath = (pathname: string): string => {
  const matchedPath = legacyEmployerPaths.find(
    (path) => matchPath(pathname, { path, exact: true })
  );

  if (!matchedPath) {
    return book.jobsListings;
  }

  const match = matchPath<Record<string, string>>(pathname, { path: matchedPath, exact: true });
  return legacyRedirects[matchedPath](match?.params ?? {});
};

export const LegacyAccountRedirect = () => {
  const { pathname, search, hash } = useLocation();

  return (
    <Redirect
      to={{
        pathname: getLegacyEmployerPath(pathname),
        search,
        hash
      }}
    />
  );
};
